export default "__VITE_ASSET__DwcTBEUV__"